import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';

const OwnerRouteGuard = ({ children }) => {
  const [ownerProfile, setOwnerProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOwnerProfile();
  }, []);

  const fetchOwnerProfile = async () => {
    try {
      const restaurantToken = localStorage.getItem('restaurantToken');
      const managerToken = localStorage.getItem('managerToken');
      
      if (!restaurantToken && !managerToken) {
        setLoading(false);
        return;
      }

      // Try restaurant token first, then manager token
      let token = restaurantToken;
      let apiEndpoint = '/api/auth/profile';
      
      if (!restaurantToken && managerToken) {
        token = managerToken;
        apiEndpoint = '/api/manager/profile';
      }

      const res = await axios.get(apiEndpoint, {
        headers: { 'x-auth-token': token }
      });
      setOwnerProfile(res.data);
    } catch (err) {
      console.error('Error fetching owner profile:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div>Загрузка...</div>;
  }

  if (!ownerProfile) {
    return <Navigate to="/login" replace />;
  }

  // If it's a manager profile, check if they have menu editing rights
  if (ownerProfile.role === 'waiter' && !ownerProfile.canManageMenu) {
    return <Navigate to="/manager/orders-page" replace />;
  }

  return children;
};

export default OwnerRouteGuard;
